import React from 'react';
import MapGL from '@urbica/react-map-gl';

const fakeLeadData = {
  type: 'Feature',
  geometry: {
    type: 'Polygon',
    coordinates: [
    ]
  }
};

class LeadMap extends React.Component {

    REGION_LAYER = 'instyle-region-layer';
    REGION_SOURCE = 'instyle-region-source';
    LEAD_SOURCE = 'instyle-lead-source';
    LEAD_LAYER = 'instyle-lead-layer';
    SUBURB_LAYER = "instyle-suburb-layer";
    SUBURB_SOURCE = "instyle-suburb-source";

    constructor(props) {
        super(props);
        this.state = {
            viewport: {
                latitude: -27.470125,
                longitude:153.021072,
                zoom: 8
            },
        }
        this._map = React.createRef();
        this.layersAdded = false;
        this.mapLoaded = false;
    }

    onMapLoaded = () => {
        if (!this.layersAdded) {
            // this._map.current._map.resize();
            this._map.current._map.addSource(this.REGION_SOURCE, {
                'type': 'geojson',
                'data': this.props.regionData
            });
            this._map.current._map.addLayer({
                id: 'instyle-region-labels',
                type: 'symbol',
                source: this.REGION_SOURCE,
                'layout': {
                    'text-field': ['get', 'name',],
                    // 'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
                    'text-radial-offset': 0.5,
                    'text-justify': 'center',
                },
                minzoom: 9,
            });
            this._map.current._map.addLayer({
                'id': this.REGION_LAYER,
                'type': 'fill',
                'source': this.REGION_SOURCE,
                'layout': {},
                'paint': {
                    'fill-color': '#0090EA',
                    'fill-opacity': 0.1,
                }
            });
            this._map.current._map.addLayer({
                'id': this.REGION_LAYER+'_LINE',
                'type': 'line',
                'source': this.REGION_SOURCE,
                'layout': {},
                'paint': {
                    'line-color': '#0090EA',
                    'line-width': 2,
                    'line-opacity': 0.4
                }
            });
            this._map.current._map.addSource(this.SUBURB_SOURCE, {
                'type': 'geojson',
                'data': this.props.suburbData
            });

            this._map.current._map.addLayer({
                'id': this.SUBURB_LAYER,
                'type': 'fill',
                'source': this.SUBURB_SOURCE,
                'layout': {},
                'paint': {
                    'fill-color': '#FF0000',
                    'fill-opacity': 0.3,
                }
            });
            this._map.current._map.addSource(this.LEAD_SOURCE, {
                'type': 'geojson',
                'data': this.props.leadData,
                'cluster': true,
                'clusterMaxZoom': 9
            });
            this._map.current._map.addLayer({
                'id': this.LEAD_LAYER+'_CLUSTER',
                'type': 'circle',
                'source': this.LEAD_SOURCE,
                filter: ['has', 'point_count'],
                paint: {
                    'circle-color': [
                        'step',
                        ['get', 'point_count'],
                        '#0090EA',
                        100,
                        '#F4A616',
                        750,
                        '#763AD5'
                    ],
                    'circle-radius': [
                        'step',
                        ['get', 'point_count'],
                        20,
                        100,
                        30,
                        750,
                        40
                    ]
                }
            }, 'instyle-region-labels');
            this._map.current._map.addLayer({
                id: 'cluster-count',
                type: 'symbol',
                source: this.LEAD_SOURCE,
                filter: ['has', 'point_count'],
                layout: {
                    'text-field': '{point_count_abbreviated}',
                    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                    'text-size': 12,
                    'text-allow-overlap': true
                }
            }, 'instyle-region-labels');
            this._map.current._map.addLayer({
                id: 'unclustered-point',
                type: 'circle',
                source: this.LEAD_SOURCE,
                filter: ['!', ['has', 'point_count']],
                paint: {
                    'circle-color': '#11b4da',
                    'circle-radius': 4,
                    'circle-stroke-width': 1,
                    'circle-stroke-color': '#fff'
                },
            }, 'instyle-region-labels');

            var selfMap = this._map.current._map;
            var selfLeadLayer = this.LEAD_LAYER+'_CLUSTER'
            var selfLeadSource = this.LEAD_SOURCE;
            this._map.current._map.on('click', selfLeadLayer, function(e) {
                var features = selfMap.queryRenderedFeatures(e.point, {
                    layers: [selfLeadLayer]
                });
                var clusterId = features[0].properties.cluster_id;
                selfMap.getSource(selfLeadSource).getClusterExpansionZoom(
                    clusterId,
                    function(err, zoom) {
                        if (err) return;

                        selfMap.easeTo({
                            center: features[0].geometry.coordinates,
                            zoom: zoom
                        });
                    }
                );
            });
            this.layersAdded = true;
        }
        this.mapLoaded = true;
    }

    componentWillReceiveProps(nextProps) {
        Object.keys(nextProps)
            .filter(key => {
                return nextProps[key] !== this.props[key];
            })
            .map(key => {
                if (key === "leadData") {
                    this.updateLeadData(nextProps[key])
                }
                if (key === "suburbData") {
                    this.updateSuburbData(nextProps[key])
                }
                return true
            });
    }

    updateLeadData = (leadData) => {
        if (this.mapLoaded) {
            this._map.current._map.getSource(this.LEAD_SOURCE).setData(leadData);
        }
    }

    updateSuburbData = (suburbData) => {
        if (this.mapLoaded) {
            this._map.current._map.getSource(this.SUBURB_SOURCE).setData(suburbData);
        }
    }

    render() {
        return (
            <React.Fragment>
                <MapGL
                    style={{ width: "100%", height: "80vh", minHeight: "80vh" }}
                    mapStyle="mapbox://styles/mapbox/light-v9"
                    accessToken={'pk.eyJ1IjoibmljaG9sb3BvbHVzIiwiYSI6ImNrM2V6OTl1cDAwdDMzbHJzdzJvd2FxdXoifQ.8GRXsHLt6V_8IjG2TbIYkA'}
                    latitude={this.state.viewport.latitude}
                    longitude={this.state.viewport.longitude}
                    zoom={this.state.viewport.zoom}
                    onViewportChange={(viewport) =>  {
                        this.setState({ viewport })
                    }}
                    ref={this._map}
                    className={`lead-map`}
                    onLoad={this.onMapLoaded}
                >
                </MapGL>
            </React.Fragment>
        )
    }
}
export default LeadMap